import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Skeleton } from '@mui/material';
import { CerebroDrawer, CerebroHeading, CerebroLink } from '../../shared/components';
import { useShowDeletedDocumentsQuery } from '../../shared/hooks';
import { DateUtils, FileUtils } from '../../shared/utils';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { GetDocumentTypeDescription } from '../../shared/utils/enum';

interface ShowDeletedDocumentsProps {
	dataRoomGuid: string | undefined;
	showDocuments: boolean;
	close: () => void;
}

export const ShowDeletedDocuments: React.FC<ShowDeletedDocumentsProps> = ({ dataRoomGuid, showDocuments, close }) => {
	const deletedQuery = useShowDeletedDocumentsQuery(dataRoomGuid, {
		enabled: showDocuments,
		retry: false,
	});

	return (
		<CerebroDrawer open={showDocuments} onClose={() => close()} PaperProps={{ sx: { width: '600px' } }}>
			<CerebroHeading size="h1" gutterBottom>
				Deleted Documents
			</CerebroHeading>

			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Name</TableCell>
							<TableCell>Type</TableCell>
							<TableCell>Date</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{deletedQuery.isLoading && (
							<>
								<Skeleton height={60} />
								<Skeleton height={60} />
								<Skeleton height={60} />
							</>
						)}
						{deletedQuery.isSuccess && (
							<>
								{deletedQuery.data.map(doc => {
									return (
										<TableRow key={doc.guid}>
											<TableCell>
												<CerebroLink
													variant="link"
													target="_blank"
													rel="noreferrer"
													href={CerebroApiEndpoints.Documents.AbsoluteDownload(
														dataRoomGuid,
														doc.guid
													)}
												>
													{FileUtils.getFileTypeIcon(doc.fileName)} {doc.name}
												</CerebroLink>
											</TableCell>
											<TableCell>{GetDocumentTypeDescription(doc.documentType)}</TableCell>
											<TableCell>
												{DateUtils.FormatStringAsShortDate(doc.documentDate.toString())}
											</TableCell>
										</TableRow>
									);
								})}
								{deletedQuery.data.length == 0 && (
									<TableRow>
										<TableCell colSpan={3} style={{ textAlign: 'center' }}>
											There are no deleted documents for this data room.
										</TableCell>
									</TableRow>
								)}
							</>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</CerebroDrawer>
	);
};
